import clsx from "clsx";
import { graphql } from "gatsby";
import { omit } from "lodash";
import React, {
  DetailedHTMLProps,
  FC,
  HTMLAttributes,
  MouseEventHandler,
  useCallback,
} from "react";

import { CommonColors } from "../../../types/colors";
import { colorScheme } from "./styles";

export interface AnchorCardProps
  extends Queries.AnchorDataFragment,
    Omit<DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, "title" | "id"> {
  color: CommonColors;
}

export const AnchorCard: FC<AnchorCardProps> = ({
  title,
  subtitle,
  color,
  className,
  slug,
  ...rest
}) => {
  const { rootClass } = colorScheme[color];
  const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      if (!slug) return;
      const hash = `#${slug}`;
      const elem = document.getElementById(slug);
      if (typeof window !== "undefined") {
        if (elem) {
          window.scrollTo({
            top: elem.offsetTop,
            behavior: "smooth",
          });
        }
        const path =
          window.location.href.indexOf("#") > -1
            ? window.location.href.replace(window.location.hash, hash)
            : `${window.location.href}${hash}`;
        window.history.pushState({ path }, "", path);
      }
      e.stopPropagation();
    },
    [slug]
  );

  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx("px-4", className)}
      {...omit(rest, "strips")}
    >
      <span className={clsx("rounded-4xl px-6 py-6 h-full flex flex-col gap-1", rootClass)}>
        <h4 className="text-3xl text-left">{title}</h4>
        <p className="font-light text-left">{subtitle}</p>
      </span>
    </button>
  );
};

export const query = graphql`
  fragment AnchorData on ContentfulAnchor {
    title
    subtitle
    slug
  }
`;
